<template>
  <div 
    :class="['bg-gray-700 border-2 rounded-lg shadow-lg w-64', selected ? 'border-green-400' : data.__validationError ? 'border-red-500' : 'border-gray-600']"
  >
    <!-- Header del nodo -->
    <div class="bg-gray-800 p-3 rounded-t-lg flex items-center gap-2 justify-between">
      <div class="flex items-center gap-2">
        <span class="material-icons text-green-400">call_split</span>
        <strong class="text-white">{{ $t('flowEditor.nodes.conditionNode.title') }}</strong>
        <Tag severity="warn" :value="$t('flowEditor.nodes.conditionNode.deprecatedBadge')" class="text-[10px]" />
      </div>
      <ValidationMarker :error="data.__validationError" />
    </div>
    
    <!-- Corpo del nodo -->
    <div class="p-3 text-sm">
      <p class="text-gray-400">{{ $t('flowEditor.nodes.conditionNode.ifLabel') }}</p>
      <p class="font-mono text-white truncate">{{ data.variableName || $t('flowEditor.nodes.conditionNode.emptyVariable') }}</p>
      <p class="text-gray-400 mt-1">{{ getOperatorLabel(data.operator) }}</p>
      <p class="font-mono text-white truncate">{{ data.value || $t('flowEditor.nodes.conditionNode.emptyVariable') }}</p>
    </div>

    <!-- Punti di connessione (Handles) -->
    <Handle type="target" :position="Position.Left" />
    <!-- Handle di output per la condizione VERA -->
    <Handle id="true" type="source" :position="Position.Right" :style="{ top: '35%' }">
      <div class="absolute -right-12 top-1/2 -translate-y-1/2 text-xs bg-green-900 text-green-300 px-2 py-1 rounded-sm">{{ $t('flowEditor.nodes.conditionNode.trueLabel') }}</div>
    </Handle>
    <!-- Handle di output per la condizione FALSA -->
    <Handle id="false" type="source" :position="Position.Right" :style="{ top: '65%' }">
      <div class="absolute -right-12 top-1/2 -translate-y-1/2 text-xs bg-red-900 text-red-300 px-2 py-1 rounded-sm">{{ $t('flowEditor.nodes.conditionNode.falseLabel') }}</div>
    </Handle>
  </div>
</template>

<script setup>
import { Handle, Position } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import ValidationMarker from './ValidationMarker.vue';

const { t } = useI18n();

defineProps({
  data: {
    type: Object,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

const getOperatorLabel = (operator) => {
  if (!operator) return t('flowEditor.nodes.conditionNode.emptyVariable');
  const key = `flowEditor.nodes.conditionNode.operators.${operator}`;
  return t(key, operator);
};
</script>